import {Expose} from 'class-transformer';

export class CardTypeGraphicTemplateApiModel {
  @Expose()
  templateId: string;

  @Expose()
  graphic: string;
}
